import React from 'react';
import admIcon from '../../assets/AdmIcon.png';

function AppLoading() {
  return (
    <div
      className="app-loading"
      role="status"
      aria-live="polite"
      aria-label="Carregando ADM Tecnologias"
    >
      <div className="app-loading__atmosphere" aria-hidden="true" />

      <div className="dash" aria-hidden="true">
        <span className="dash__slot dash__slot--kpi" />
        <span className="dash__slot dash__slot--ring" />
        <span className="dash__slot dash__slot--list" />
        <span className="dash__slot dash__slot--chart" />
        <span className="dash__slot dash__slot--mini" />
        <span className="dash__slot dash__slot--mark" />

        <article className="tile tile--kpi">
          <span className="tile__meta" />
          <span className="tile__bars">
            <span /><span /><span /><span /><span />
          </span>
        </article>

        <article className="tile tile--ring">
          <span className="tile__ring" />
        </article>

        <article className="tile tile--list">
          <span className="tile__rows">
            <span /><span /><span /><span />
          </span>
        </article>

        <article className="tile tile--chart">
          <span className="tile__tracks">
            <span /><span /><span />
          </span>
        </article>

        <article className="tile tile--mini">
          <span className="tile__stack">
            <span /><span />
          </span>
        </article>

        <article className="tile tile--mark">
          <span className="tile__spark" />
        </article>
      </div>

      <div className="app-loading__brand">
        <img src={admIcon} alt="" className="app-loading__mark" />
        <p className="app-loading__name">ADM Tecnologias</p>
        <p className="app-loading__status">Montando o sistema</p>
      </div>
      <div className="app-loading__progress" aria-hidden="true">
        <span />
      </div>
    </div>
  );
}

export default AppLoading;
